import { MarkdownBlock } from './MarkdownBlock';

export class MarkdownParagraph extends MarkdownBlock {
  constructor(protected text: string) {
    super();
  }

  toString(): string {
    return this.text;
  }
}
